import { Injectable } from '@angular/core';

@Injectable()
export class Basemaps {
    basemapList = 'terrain,streets-vector,satellite,hybrid,topo-vector,gray-vector,osm';
    defaultBasemap = {
      'tileUrl': 'https://gis.penndot.pa.gov/gis/rest/services/basemaps/penndotbasemap/MapServer/tile',
      'thumbnailTile': '/7/48/36',
      'tileTemplate': '/{level}/{row}/{col}',
      'title': 'PennDOT'
    };
    basemapConfigs: any[] = [
    {
        "tileUrl": "https://services.arcgisonline.com/ArcGIS/rest/services/Elevation/World_Hillshade/MapServer/tile",
        "thumbnailTile": "/15/12358/9365",
        "tileTemplate": "/{level}/{row}/{col}",
        "title": "Elevation"
    },
    {
      "tileUrl": "https://services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer/tile",
      "thumbnailTile": "/7/48/36",
      "tileTemplate": "/{level}/{row}/{col}",
      "title": "Topographic DRG"
    }
    ];
}